module.exports = __webpack_public_path__ + "static/img/1050@2x.806e521f.png";